import { IScreen } from './iScreen';

class OptionsScreen implements IScreen{

    constructor(){
        
    }

    setup(){
        
    }

    windowResized(): void {
        
    }

    draw(){
        buffer.background(0);

        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.fill(255);
        buffer.textSize(35);
        buffer.noStroke();
        buffer.text("Options", 0, -100);
        buffer.textSize(15);

        let txt = "You have no options";
        buffer.text(txt, 0, 0);

        buffer.textSize(24);
        buffer.fill(205 + (p5js.sin(p5js.frameCount / 5.0) * 25), 0, 0);
        buffer.text("> Okay <", 0, 100);
    }

    keyPressed(){
        if(p5js.keyCode === p5js.ESCAPE || p5js.keyCode == p5js.ENTER || p5js.key == ' '){
            currentScreen = "mainMenu";
            iScreen = screens[currentScreen];
            //iScreen = new MainMenuScreen(p5js);
            return;
        }
    }

    keyReleased(){
        
    }

    mousePressed(){
        
    }

    mouseReleased(){
        
    }

    touchStarted(){
        
    }

    touchEnded(){
        
    }

    touchMoved(): void {
        
    }

    mouseWheel(event: any): void {
        
    }

}

export default OptionsScreen;